import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Dashlet from '../components/features/Dashlet.jsx';
import { LanguageLoader } from '../assets/languages/index.js';

const Dashboard = () => {
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);	
	const chartDashlets = settings.dashlets?.chart ?? [];
	const evaluationDashlets = chartDashlets.filter(d => d.module === "Evaluation");
	const otherChartDashlets = chartDashlets.filter(d => d.module !== "Evaluation");
	const [evaluationCount, setEvaluationCount] = useState(0);
	const colClass = {
		1: 'col-span-1',
		2: 'col-span-2',
		3: 'col-span-3',
		4: 'col-span-4',
	}[Math.min(evaluationCount, 4)] || 'col-span-1';

	return(
		<React.Fragment>
			{settings.messages && settings.messages.general && settings.messages.general.length ?
				<div className="wrapper" dangerouslySetInnerHTML={{__html: settings.messages.general}}></div>
			: null}
			{evaluationDashlets.length ?
				<div className={`grid grid-cols-4 gap-x-4`}>
					<div className={colClass}>
						<Dashlet 
							key={0} 
							structure='chart'
							data={evaluationDashlets[0]} 
							onCountLoad={setEvaluationCount}
						/>
					</div>
				</div>
			: null}
			{otherChartDashlets.length ?
				<div className="grid min-[1600px]:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 gap-x-4">
					{otherChartDashlets.map((data, index) => <Dashlet key={index} structure='chart' data={data}/>)}
				</div>
			: null}
			{settings.dashlets.basic && settings.dashlets.basic.length ?
				<div className="grid min-[1600px]:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 gap-x-4">
					{settings.dashlets.basic.map((data, index) => <Dashlet key={index} structure='basic' data={data}/>)}
				</div>
			: null}
			{!settings.dashlets.chart && !settings.dashlets.basic ?
				<div>{language.NO_DASHLET}</div>
			: null}
		</React.Fragment>
	);
}

export default Dashboard;